import React, { ReactNode } from 'react';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material';

interface Props {
  title: string;
  subtitle: string;
  expanded: boolean;
  onToggle: () => void;
  // Rendered only while expanded — pass a <RuleForm /> (or nothing while collapsed).
  children?: ReactNode;
}

// Purely presentational — knows nothing about rules/criteria, just an expand/collapse row with a
// title + subtitle and caller-supplied content. Reusable anywhere an accordion-style editable list
// row is needed.
function RuleAccordionItem({ title, subtitle, expanded, onToggle, children }: Props) {
  return (
    <Accordion expanded={expanded} onChange={onToggle} disableGutters>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Box>
          <Typography variant="body2">{title}</Typography>
          <Typography variant="caption" color="text.secondary">
            {subtitle}
          </Typography>
        </Box>
      </AccordionSummary>
      {/* Content only mounted while expanded, so re-opening always starts fresh rather than
          carrying over an abandoned in-progress edit. */}
      <AccordionDetails>{expanded && children}</AccordionDetails>
    </Accordion>
  );
}

export default RuleAccordionItem;
